export default __webpack_public_path__ + "static/media/locar.cd3203ac.PNG";